import React from 'react';
import {SettingOutlined} from "@ant-design/icons";
import {useMainLayoutContext} from "../../../index";
import {useNavigate} from "react-router-dom";

function HeaderSetting(props) {

    const navigate = useNavigate()

    const {type} = useMainLayoutContext()

    function onClick() {

        if (type === "setting") {
            navigate("/hrm/timekeeping/time-sheet/timesheet")
        } else {
            navigate("/setting/timekeeping/timekeeping-settings")
        }
    }
    return (

        <SettingOutlined
            onClick={onClick}
            className={"transition-all cursor-pointer p-[11px] text-[var(--primary-text-color)] rounded-full hover:bg-gray-200"}
            style={{
                fontSize: "var(--primary-icon-size)",
                color: type === "setting" ? 'var(--primary-color)' : 'var(--primary-text-color)'
            }}
        />

    );
}

export default HeaderSetting;